import * as React from 'react';
import { useSelector } from 'react-redux';
import { betreuerByNrSelector } from 'store/lookups/selector';
import moment from 'moment-timezone';
import { AuftragStatusLabel } from 'utils/labels';
import { formStyles } from 'styles/formStyles';
import { FilterValues } from './types';

interface FilterInfoProps {
    filterValues: FilterValues;
}

export const FilterInfo: React.FC<FilterInfoProps> = ({ filterValues: { betreuer, telBetreuer, status } }) => {
    const betreuerByNr = useSelector(betreuerByNrSelector);

    return (
        <table className={formStyles.reportFilterInfo}>
            <tr>
                <td>Druckdatum: </td>
                <td>{moment().format('DD.MM.YYYY HH:mm:ss')}</td>
            </tr>
            {betreuer && (
                <tr>
                    <td>Betreuer:</td>
                    <td>{betreuerByNr[betreuer]?.name || betreuer}</td>
                </tr>
            )}
            {telBetreuer && (
                <tr>
                    <td>Tel.-Betreuer:</td>
                    <td>{betreuerByNr[telBetreuer]?.name || telBetreuer}</td>
                </tr>
            )}
            {status && (
                <tr>
                    <td>Status:</td>
                    <td>{AuftragStatusLabel[status] || status}</td>
                </tr>
            )}
        </table>
    );
};
